import type { CardFormValues } from './validation'

/** 카드 등록 폼 초기값 */
export const INITIAL_FORM: CardFormValues = {
  identificationType: 'PERSONAL',
  cardNo: '',
  expMonth: '',
  expYear: '',
  idNo: '',
  cardPw: '',
}
